// IM-EXT-004 — mensagem de erro exibível. A tela nunca mostra texto técnico (TypeError, stack, "Erro 500"):
// erros de regra do servidor (4xx com mensagem própria) são repassados; o resto vira texto de negócio + código de suporte.
// O detalhe técnico vai para o console, para diagnóstico.
import { ApiError } from '../api/client';

export function friendlyError(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    const ref = err.correlationId ? ` (código de suporte: ${err.correlationId.slice(0, 8)})` : '';
    if (err.status === 429) return err.message || 'Muitas tentativas. Aguarde alguns instantes e tente novamente.';
    if (err.status < 500 && err.code !== 'http_error' && err.message) return err.message;
    console.error('[InteliMove]', err.status, err.code, err.correlationId, err.message);
    return `${fallback}${ref}`;
  }
  console.error('[InteliMove]', err);
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return 'Sem conexão com a internet. Verifique a rede e tente novamente.';
  return fallback;
}
